import { render, staticRenderFns } from "./mergeAcount-success.vue?vue&type=template&id=173f0904&scoped=true"
import script from "./mergeAcount-success.vue?vue&type=script&lang=js"
export * from "./mergeAcount-success.vue?vue&type=script&lang=js"
import style0 from "./mergeAcount-success.vue?vue&type=style&index=0&id=173f0904&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173f0904",
  null
  
)

export default component.exports